import { CalendarIcon, TrendingUpIcon } from "lucide-react";
import { Badge } from "src/components/ui/badge";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "src/components/ui/card";
import { calculateIRRate } from "../functions";

export const renderInvestmentCard = (
  investmentType: string,
  yieldValue: string,
  months: number
) => {
  const irRate = calculateIRRate(months);
  const isExempt = [
    "LCI",
    "LCA",
    "CRI",
    "CRA",
    "DEBÊNTURE INCENTIVADA",
  ].includes(investmentType);

  const getPeriodText = (months: number) => {
    if (months <= 6) return "Curto prazo (até 180 dias)";
    if (months <= 12) return "Médio prazo (181 a 360 dias)";
    if (months <= 24) return "Médio-longo prazo (361 a 720 dias)";
    return "Longo prazo (acima de 720 dias)";
  };

  return (
    <Card className="mt-4 sm:flex-1 overflow-hidden w-full">
      <CardHeader className="bg-primary text-primary-foreground p-4">
        <CardTitle className="text-xl font-bold">{investmentType}</CardTitle>
      </CardHeader>
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center space-x-2">
          <TrendingUpIcon className="w-6 h-6 text-green-500" />
          <span className="text-lg font-semibold">
            Rentabilidade Líquida (a.a):
          </span>
          <span className="text-2xl font-bold text-green-600">
            {yieldValue}%
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <CalendarIcon className="w-6 h-6 text-blue-500" />
          <span className="text-lg font-semibold">Período:</span>
          <span className="text-xl font-bold text-blue-600">
            {months} meses
          </span>
        </div>

        <Badge
          variant={"default"}
          className={`text-sm py-1 px-2 hover:bg-opacity-90 ${
            isExempt
              ? "bg-primary"
              : "bg-[#fef3c7] hover:bg-[#fef3c7] text-black"
          }`}
        >
          {getPeriodText(months)}
        </Badge>

        {isExempt ? (
          <div className="bg-green-100 text-green-800 p-3 rounded-md">
            <p className="font-semibold m-0 text-sm">
              Este investimento é isento de Imposto de Renda.
            </p>
          </div>
        ) : (
          <div className="bg-amber-100 text-amber-800 p-3 rounded-md">
            <p className="font-semibold text-sm">
              % Alíquota do IR:{" "}
              <span className="text-lg font-bold m-0">
                {(irRate * 100).toFixed(1)}%
              </span>
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
